import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { PermissionService } from 'app/core/permission/permission.service';
import { map } from 'rxjs/operators';

/** SuperAdmin lands on My Home; everyone else keeps Accounting dashboard. */
export function resolvePostLoginHomePath(
  permission: PermissionService = inject(PermissionService)
): string {
  return permission.isSuperAdmin() ? '/my-home' : '/accounting/dashboard';
}

/**
 * After sign-in / root `/`: SuperAdmin → My Home, everyone else → Accounting dashboard.
 * Waits for `AuthService.check()` so profile (and `isSuperAdmin`) is loaded — otherwise
 * cold open of `/` on a deployed host sends SuperAdmin to Accounting by mistake.
 */
export const myHomePostLoginRedirect: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permission = inject(PermissionService);

  return auth.check().pipe(
    map((authenticated) => {
      if (!authenticated) {
        return router.createUrlTree(['/sign-in']);
      }
      return router.createUrlTree([resolvePostLoginHomePath(permission)]);
    })
  );
};
